import {types} from './types';

const initialState = {
    list: [],
    list_stat: [],
    view: {
        start: NaN,
        end: NaN,
        label_name: '',
        description: '',
        fund: '0',
        count_winners: '1',
        min_bet: '0',
        count_spin: '10',
        winners: [0],
        games: [],
        gameIds: []
    },
    games: []
}

export function tournamentReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        case types.SET_VIEW:
            return { ...state, view: action.payload};
        case types.SET_LIST_STAT:
            return { ...state, list_stat: action.payload};
        case types.SET_SEARCH_GAME:
            return { ...state, games: action.payload};
        default:
            return state
    }
}